import { ANY, CITY, COMPANY, DISCIPLINE, EMPLOYMENT_TYPE, ROLE, SKILL } from '../constants';
import { SerpsRouteInfo } from '../hooks/use-serps-match';
import {
  companySlugToLocalizedString,
  deslugify,
  disciplineSlugToId,
  employmentTypeSlugToId,
  skillSlugToLocalizedString,
} from './static-data-utils';

const DEFAULT_RADIUS = 20;

export const serpsSearchQuery = ({ category, categoryValue, subcategory, subcategoryValue }: SerpsRouteInfo) => {
  const filter = {
    ...(category === DISCIPLINE && { discipline: { id: [disciplineSlugToId(categoryValue)] } }),
    ...(subcategory === DISCIPLINE &&
      subcategoryValue && { discipline: { id: [disciplineSlugToId(subcategoryValue)] } }),
    ...(category === EMPLOYMENT_TYPE && { employmentType: { id: [employmentTypeSlugToId(categoryValue)] } }),
    ...(subcategory === EMPLOYMENT_TYPE &&
      subcategoryValue && { employmentType: { id: [employmentTypeSlugToId(subcategoryValue)] } }),
  };

  return {
    ...(category === CITY && {
      location: { text: deslugify(categoryValue), radius: DEFAULT_RADIUS },
    }),
    ...(subcategory === CITY &&
      subcategoryValue && {
        location: { text: deslugify(subcategoryValue), radius: DEFAULT_RADIUS },
      }),
    ...(category === ROLE && { keywords: deslugify(categoryValue) }),
    ...(category === COMPANY && { keywords: companySlugToLocalizedString(categoryValue) }),
    ...(category === SKILL && { keywords: skillSlugToLocalizedString(categoryValue) }),
    ...(category === ANY && { keywords: deslugify(categoryValue) }),
    ...(subcategory === ROLE && subcategoryValue && { keywords: deslugify(subcategoryValue) }),
    ...(Object.keys(filter).length > 0 && { filter }),
  };
};
